export const MAX_SURFACE_MEMORY_VALUE_LENGTH = 200;
export const PAGE_EDITOR_SECTION_ID = 'page-editor';
export const SIDEBAR_SECTION_ID = 'page-editor-sidebar';
export const CANVAS_SECTION_ID = 'page-editor-canvas';
export const SELECTION_SECTION_ID = 'page-editor-selection';
export const MODAL_SECTION_ID = 'active-modal';